// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    DeleteReviewIntelligentPartnerCourseScoresByIdParam,
    BaseResponseVoid,
} from '../../types';

/**
 * deleteById
 *
 * @export
 * @tags review-intelligent-partner-course-score-controller
 * @link [DELETE] /reviewIntelligentPartnerCourseScores/{id}
 * @param id
 */
export function deleteReviewIntelligentPartnerCourseScoresById(
    options: ApiOptions<DeleteReviewIntelligentPartnerCourseScoresByIdParam, never> & {
        segments: DeleteReviewIntelligentPartnerCourseScoresByIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<never, DeleteReviewIntelligentPartnerCourseScoresByIdParam, never>(
        '/reviewIntelligentPartnerCourseScores/{id}',
        {
            ...options,
            method: 'delete',
            __$requestCalleeName: 'deleteReviewIntelligentPartnerCourseScoresById',
        }
    );
}

export const meta = [
    {
        tags: ['review-intelligent-partner-course-score-controller'],
        path: '/reviewIntelligentPartnerCourseScores/{id}',
        method: 'delete',
    },
];
